import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type {
	CreateCustomViewArgs,
	GenericDeleteArgs,
	UpdateCustomViewArgs,
} from "../types"

export const customViewMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateCustomViewArgs
			ctx: ZeroJwtPayload
		}) => {
			const [existing] = await tx.query.customViews
				.where("id", "=", args.id)
				.run()

			if (existing) {
				throw new Error("Custom view already exists")
			}

			await tx.mutate.customViews.insert({
				id: args.id,
				name: args.name,
				slug: args.slug,
				icon: args.icon,
				filters: args.filters,
				sortOrder: args.sortOrder,
				surface: args.surface ?? "threads",
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				workspaceId: authData.workspaceId,
			})
		},
	),

	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateCustomViewArgs }) => {
			await tx.mutate.customViews.update({
				id: args.id,
				...(args.name !== undefined && { name: args.name }),
				...(args.icon !== undefined && { icon: args.icon }),
				...(args.filters !== undefined && { filters: args.filters }),
				...(args.sortOrder !== undefined && { sortOrder: args.sortOrder }),
				updatedAt: Date.now(),
			})
		},
	),

	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: GenericDeleteArgs }) => {
			await tx.mutate.customViews.delete({ id: args.id })
		},
	),
}
